<template>
  <ScreenAdapter>
    <div id="main">
      <Header />
      <Nav />
      <div class="platform-cover" :style="`background:url(${cover}) no-repeat center/cover`"></div>
      <div class="eol-main-container">
        <div class="business-content" ref="111">
          <div class="content-header">
            <div class="text">商道传承</div>
          </div>
          <div class="content-box">
            <div class="business-bg">
              <div class="business-content">
                <div class="swiper-content" v-if="imprintData && imprintData.length > 0">
                  <swiper :options="thoughtSwiperOption">
                    <swiper-slide :style="`background-image: url('${item.photo}');`" v-for="item in imprintData" :key="item.id" :data-id="item.id">
                    </swiper-slide>
                  </swiper>
                  <div class="swiper-pagination business"></div>
                  <!-- 
                <div class="swiper-button-next business"></div>
                <div class="swiper-button-prev business"></div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 艺着风华 -->
        <div class="value-content" ref="112">
          <div class="content-header">
            <div class="text">艺者风华</div>
          </div>
          <div class="content-box">
            <div class="content-item" v-for="(item,index) in artData" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover`" @click="jumpDetail(item)"></div>
            <div class="flex-hide"></div>
          </div>
        </div>
        <!-- 浙江印迹 -->
        <div class="spirit-content" ref="113">
          <div class="content-header">
            <div class="text">浙江印迹</div>
          </div>
          <div class="content-box">
            <div class="content-item" v-for="(item,index) in businessData" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover`" @click="jumpDetail(item)"></div>
            <div class="flex-hide"></div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </ScreenAdapter>

</template>

<script>
import Header from "@/components/Hzvtc/Header.vue"
import Nav from "@/components/Hzvtc/Nav.vue"
import Footer from "@/components/Hzvtc/Footer.vue"
import services from '../../../config/services'
import ScreenAdapter from "@/components/ScreenAdapter.vue"

export default {
  data () {
    let that = this
    return {
      cover: require("../../../assets/hzvtc/cover/feature.png"),
      school_code: services.HZ_CODE,
      thoughtSwiperOption: {
        effect: "coverflow",
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 0,
          stretch: 350,
          depth: 150,
          modifier: 1,
          slideShadows: false,
        },
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        preventClicksPropagation: false,
        // navigation: {
        //   // 前进后退按钮 ,不同版本配置方式不同
        //   nextEl: `.swiper-button-next.business`,
        //   prevEl: `.swiper-button-prev.business`,
        // },
        pagination: {
          el: `.swiper-pagination.business`,
        },
        on: {
          click: function (v) {
            let id = v.target.getAttribute("data-id");
            if (id) {
              window.open(`/center/${that.school_code}/hzvtc/detail?id=${id}&key=feature`, "_blank")
            }

          },
        },
      },
      businessData: [], // 浙江印记
      artData: [], // 艺者风华
      imprintData: [], // 商道传承
    }
  },
  components: {
    Header,
    Nav,
    Footer,
    ScreenAdapter
  },
  mounted () {
    this.getListData()
  },
  methods: {
    async getListData () {

      // 商道传承
      await services.getCourseList({ page: 1, size: 100, category_id: "202", school_code: this.school_code }).then(res => {
        this.imprintData = res.data.items
      })


      // 艺者风华
      await services.getCourseList({ page: 1, size: 2, category_id: "201", school_code: this.school_code }).then(res => {
        this.artData = res.data.items
      })

      // 浙江印迹
      await services.getCourseList({ page: 1, size: 2, category_id: "200", school_code: this.school_code }).then(res => {
        this.businessData = res.data.items
      })


      // await this.jumpPosition()

    },
    // 锚点定位
    jumpPosition () {
      let that = this
      let position = that.$route.query.id
      if (position) {
        that.$nextTick(() => {
          let topVal = this.$refs[position].getBoundingClientRect().top
          let element = document.getElementsByClassName("outContainer")[0]
          element.scrollTop = topVal - 100
        })
      }
    },
    // 跳转到详情
    jumpDetail (item) {
      window.open(`/center/${this.school_code}/hzvtc/detail?id=${item.id}&key=feature`, "_blank")
    },
  },
}
</script>

<style lang="less" scoped>
#main {
  background: #fff;
}
.platform-cover {
  width: 100%;
  height: 510px;
}

.eol-main-container {
  width: 1400px;
  margin: 0 auto;
  padding: 72px 0 70px;
  .content-header {
     width: 1400px;
    margin: 0 auto 30px;
    font-weight: bold;
    font-size: 42px;
    color: #B61E2A;
    background: linear-gradient(0deg, #B61E2A 0%, #EF350A 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
    position: relative;
    z-index: 2;
    &::after {
      width: 1400px;
      margin-top: 16px;
      height: 35px;
      content: "";
      display: block;
      background-image: url("../../../assets/hzvtc/list/hzdx-title.png");
      background-size: cover;
      background-position: center;
      // position: absolute;
    }
  }
  .content-box {
    position: relative;
    z-index: 10;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .content-item {
      width: 446px;
      height: 251px;
      cursor: pointer;
      margin-bottom: 30px;
    }
    .flex-hide {
      flex: 0 0 446px;
      visibility: hidden;
      display: block;
    }
  }

  .business-content {
    position: relative;
    padding: 0 0 30px;
     .content-header {
      margin: 0 auto;
     }
    .content-box {
      .swiper-slide {
        width: 863px !important;
        height: 485px !important;
        .cover {
          width: 100%;
          height: 100%;
        }
      }

      ::v-deep .swiper-pagination {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: -32px;
        left: 50%;
        transform: translateX(-50%);
      }
      ::v-deep .swiper-pagination-bullet {
        width: 7px;
        height: 7px;
        background: #b61e2a;
        opacity: 0.5;
        border-radius: 50%;
        display: block;
        transition: all 0.3s;
        margin-right: 4px;
      }

      ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
        width: 13px;
        height: 7px;
        background: #b61e2a;
        border-radius: 3px;
        opacity: 1;
        margin-right: 7px;
      }
    }
  }
  .value-content {
    position: relative;
    padding: 74px 0 18px;
    background: #ffe093;
    z-index: 10;
    height: 700px;
    &::before {
      content: '';
      display: inline-block;
      width: 1920px;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      height: 452px;
      position: absolute;
      background: url('../../../assets/hzvtc/list/feature-bg.png') no-repeat
        center/cover;
    }
    .content-header {
      margin-bottom: 62px;
      font-weight: bold;
      -webkit-text-fill-color: unset !important;
      .text {
        color: #fedfa8;
        background: unset;
      }
    }

    &::after {
      content: '';
      display: inline-block;
      width: 100%;
      height: 660px;
      position: absolute;
      top: 18px;
      background: url('../../../assets/hzvtc/list/feature-list-bg.png')
        no-repeat center/cover;
    }
    .content-box {
      justify-content: space-between;
      padding: 0 40px;
      .content-item {
        width: 636px;
        height: 358px;
      }
    }
  }
  .spirit-content {
    position: relative;
    &::after {
      content: '';
      display: inline-block;
      position: absolute;
      top: -76px;
      background: #fffdf7;
      width: 1920px;
      left: 50%;
      height: 760px;
      transform: translateX(-50%);
    }
    .content-header {
      margin: 75px 0 76px;
    }
    .content-box {
      justify-content: space-between;
      .content-item {
        width: 677px;
        height: 381px;
        position: relative;
        &::before {
          content: '';
          display: inline-block;
          position: absolute;
          background: #b61e2a;
          width: 100%;
          height: calc(100% + 60px);
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: -1;
        }
      }
    }
  }
}

.business-bg {
  background-position: center;
  background-size: cover;
  padding: 56px 0 0;
  .business-content {
    width: 1400px;
    margin: 0 auto;
    position: relative;

    &::before {
      content: '';
      display: inline-block;
      width: 1920px;
      height: 452px;
      background: linear-gradient(
        0deg,
        #fff4d7 0%,
        rgba(255, 245, 222, 0) 100%
      );
      opacity: 0.54;
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
    }
    .swiper-content {
      position: relative;
      width: 100%;
      height: 542px;
      display: flex;
      align-items: center;
      .swiper-container {
        height: 100%;
        .swiper-wrapper {
          .swiper-slide {
            width: 863px;
            height: 485px;
            background: #fff;
            background-size: 100% auto;
            background-position: center;
            cursor: pointer;
            &.swiper-slide-active {
              -webkit-transform: translate3d(0px, 0px, 0px) rotateX(0deg)
                rotateY(0deg) !important;
              -moz-transform: translate3d(0px, 0px, 0px) rotateX(0deg)
                rotateY(0deg) !important;
              -o-transform: translate3d(0px, 0px, 0px) rotateX(0deg)
                rotateY(0deg) !important;
              -ms-transform: translate3d(0px, 0px, 0px) rotateX(0deg)
                rotateY(0deg) !important;
              transform: translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(0deg) !important;
              border: 2px solid red;
            }
          }
        }
      }
      /deep/ .swiper-pagination {
        bottom: 10px;
        width: 100%;
        .swiper-pagination-bullet {
          width: 10px;
          height: 10px;
          background: #ffbe8f;
          border-radius: 50%;
          margin: 0 5px;
        }
        .swiper-pagination-bullet.swiper-pagination-bullet-active {
          width: 10px;
          height: 10px;
          background: #b70000;
          border-radius: 50%;
        }
      }
      .swiper-button-next,
      .swiper-button-prev {
        flex-shrink: 0;
        background-size: cover;
        z-index: 100;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        width: 40px;
        height: 40px;
      }
      .swiper-button-prev {
        left: -84px;
        background: url('../../../assets/hzvtc/list/value-prev.png') no-repeat
          center/cover;
      }
      .swiper-button-next {
        right: -84px;
        background: url('../../../assets/hzvtc/list/value-next.png') no-repeat
          center/cover;
      }
    }
  }
}
::v-deep .footer-container {
  position: relative;
  z-index: 10;
}
</style>